export default __webpack_public_path__ + "static/media/thum_intro_Nagami.42608657.PNG";